import React from 'react';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';
import { ApolloProvider } from '@apollo/client';
import client from '@general/graphql/client';
import { rootReducer } from '../../../reducers/FoundationDonationReducer';
import FoundationDonationContent from './FoundationDonationContent';

const FoundationDonation = ({ store }) => (
    <ApolloProvider client={client}>
        <Provider store={store}>
            <FoundationDonationContent />
        </Provider>
    </ApolloProvider>
);

FoundationDonation.propTypes = {
    store: PropTypes.any.isRequired,
};

FoundationDonation.reducers = {
    FoundationDonation: rootReducer,
};

export default FoundationDonation;
